window.$ = require('jquery');

window.website  = {

    headerNavItemDropdownButton: 'js-header-nav-dropdown-button',
    headerNavItemDropdown: 'js-header-nav-dropdown',

    init: function() {
        window.shared.$document.on(
            'click',
            ':not(.' + this.headerNavItemDropdownButton + '):not(.' + this.headerNavItemDropdown + ')',
            this.createWindowClickListener()
        );
        window.shared.$body.on('click', '.' + this.headerNavItemDropdownButton, this.createHeaderDropdownClickListener());
    },

    /**
     * @see https://codepen.io/bassta/pen/ndfDq
     * @returns {Function}
     */
    createWindowClickListener: function () {
        var self = this;
        return function (event) {
            event.stopPropagation();
            var $headerNavItemDropdown = $('.' + self.headerNavItemDropdown);

            if ($headerNavItemDropdown.has(event.target).length === 0 && !$headerNavItemDropdown.is(event.target)) {
                $headerNavItemDropdown.removeClass('is-open');
                $('.' + self.headerNavItemDropdownButton).removeClass('is-open');
            }
        }
    },

    /**
     *
     * @returns {Function}
     */
    createHeaderDropdownClickListener: function () {
        var self = this;
        return function (event) {
            event.preventDefault();
            event.stopPropagation();
            var $dropdown = $('.' + self.headerNavItemDropdown);
            var $button = $(this);

            $button.toggleClass('is-open');
            $dropdown.toggleClass('is-open');

            $button.blur();
        }
    }
};